import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/special_subject_add_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-a328b576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_role_view_bg" }
const _hoisted_2 = { class: "top_view" }
const _hoisted_3 = { class: "background_img_content" }
const _hoisted_4 = { class: "tab_action_bg" }
const _hoisted_5 = { class: "model-wrapper-bg" }
const _hoisted_6 = {
  class: "model-wrapper",
  style: {"overflow":"auto"}
}
const _hoisted_7 = ["infinite-scroll-disabled"]
const _hoisted_8 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["infinite-scroll-disabled"]
const _hoisted_11 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "useing_tips"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "add_button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "creat_tips_text" }, "点击上传")
], -1))
const _hoisted_17 = {
  key: 0,
  class: "delete_tips"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_SubViewLoadingView = _resolveComponent("SubViewLoadingView")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "submit_button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, "确认")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          class: _normalizeClass(['tab_button', _ctx.selectedTab == 0 ? 'tab_button_selected' : 'tab_button_normal']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabActionClick(0)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("发现")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_button, {
          class: _normalizeClass(['tab_button', _ctx.selectedTab == 1 ? 'tab_button_selected' : 'tab_button_normal']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabActionClick(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("我的")
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.selectedTab == 0)
            ? _withDirectives((_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: "ava-wrapper",
                "infinite-scroll-disabled": _ctx.noMoreBackListData
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backList, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.url,
                    onClick: ($event: any) => (_ctx.selectBack(item)),
                    onMouseenter: ($event: any) => (_ctx.handleBgMouseEnter(index)),
                    onMouseleave: ($event: any) => (_ctx.handleBgMouseLeave(index)),
                    style: _normalizeStyle(_ctx.itemBgStyle(index))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['back_img_bg', item.url === _ctx.backgroundItem.url ? 'active-border' : ''])
                    }, [
                      _createElementVNode("img", {
                        class: "bg_item",
                        src: item.url,
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ], 2)
                  ], 44, _hoisted_8))
                }), 128))
              ], 8, _hoisted_7)), [
                [_directive_infinite_scroll, _ctx.getBackGroundImgListRequest]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("ul", {
                key: 1,
                class: "ava-wrapper",
                "infinite-scroll-disabled": _ctx.noMoreMyBackListData
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myBackGroundList, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.url,
                    onClick: ($event: any) => (_ctx.selectBack(item)),
                    onMouseenter: ($event: any) => (_ctx.handleMyBgMouseEnter(index)),
                    onMouseleave: ($event: any) => (_ctx.handleMyBgMouseLeave(index)),
                    style: _normalizeStyle(_ctx.itemMyBgStyle(index))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['back_img_bg', item.url === _ctx.backgroundItem.url ? 'active-border' : ''])
                    }, [
                      _createElementVNode("img", {
                        class: "bg_item",
                        src: item.url,
                        alt: ""
                      }, null, 8, _hoisted_12),
                      _createElementVNode("button", {
                        class: "delete_button",
                        onClick: _withModifiers(($event: any) => (_ctx.deleteItemButtonClick(index)), ["stop"])
                      }, [
                        _createElementVNode("img", {
                          src: require('../assets/images/delete_button_icon.svg'),
                          alt: ""
                        }, null, 8, _hoisted_14)
                      ], 8, _hoisted_13),
                      (item.haveUsed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "使用中"))
                        : _createCommentVNode("", true)
                    ], 2)
                  ], 44, _hoisted_11))
                }), 128)),
                _createElementVNode("li", null, [
                  _createVNode(_component_el_upload, {
                    action: "",
                    class: "upload_el_view",
                    drag: "",
                    accept: "image/png,image/jpeg",
                    "on-error": _ctx.handleError,
                    "on-success": _ctx.handleSuccess,
                    "http-request": (item) => _ctx.uploadImg(item.file),
                    "before-upload": _ctx.beforeUPload,
                    "show-file-list": false
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["on-error", "on-success", "http-request", "before-upload"])
                ])
              ], 8, _hoisted_10)), [
                [_directive_infinite_scroll, _ctx.getMyBackGroundImgListRequest]
              ])
        ]),
        (_ctx.selectedTab == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*注意：删除后将恢复为默认背景"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_SubViewLoadingView, { msg: _ctx.subLoadingInfo }, null, 8, ["msg"])
  ]))
}